import {DashboardType} from "../../model/dashboard/types";
import {DashboardConfig} from "../../model/dashboard/dashboard-config";
import {getRootProjects} from "../../modals/add-widget/categories/helprs";
import {WidgetType} from "../../model/widget/widget-type";
import {CounterType} from "../../widgets/constants/types";
import {generateUniqueId} from "../../../../gd/utils/misc/generate-unique-id";

export function personalDashboardConfig() {


    const widgetsConfig: any = [
        {
            "cardLayout": "left",
            "settings": {
                "includeSubFolders": true,
                "showClosedTasks": false,
                "displayPropertyFieldId": "projectId",
                "includeSubtasks": true
            },
            "color": 16,
            "conditions": {
                "conditions": [
                    {
                        "type": "date-relative-before",
                        "id": "cond1",
                        "value": 0,
                        "systemFieldId": "task.deadline"
                    },
                    {
                        "type": "includes",
                        "id": "cond2",
                        "value": [
                            gd.user.id
                        ],
                        "systemFieldId": "task.assignedToUserId"
                    }
                ],
                "logicalOperator": "AND"
            },
            "title": "Pastdue tasks",
            "gridPosition": {
                "y": 0,
                "h": 2,
                "w": 4,
                "x": 0
            },
            "type": "task-list",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "left",
            "settings": {
                "includeSubFolders": true,
                "showClosedTasks": false,
                "displayPropertyFieldId": "projectId",
                "includeSubtasks": true
            },
            "color": 16,
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "cond3",
                        "value": [
                            10,
                            9,
                            8,
                            7,
                            50,
                            100
                        ],
                        "systemFieldId": "task.priority"
                    },
                    {
                        "type": "includes",
                        "id": "d6wj",
                        "value": [
                            gd.user.id
                        ],
                        "systemFieldId": "task.assignedToUserId"
                    }
                ],
                "logicalOperator": "AND"
            },
            "title": "High priority",
            "gridPosition": {
                "y": 0,
                "h": 2,
                "w": 4,
                "x": 4
            },
            "type": "task-list",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "timeFormat": "h:mm:ss A",
                // "timezone": "America/Toronto",
                "displayDate": true
            },
            "color": 6,
            "conditions": null,
            "title": "Time",
            "gridPosition": {
                "y": 0,
                "h": 1,
                "w": 4,
                "x": 8
            },
            "type": "clock",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "timeFormat": "h:mm:ss A",
                "timezone": "America/Los_Angeles",
                "displayDate": true
            },
            "color": 6,
            "conditions": null,
            "title": "California time",
            "gridPosition": {
                "y": 1,
                "h": 1,
                "w": 4,
                "x": 8
            },
            "type": "clock",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "eventTypes": [
                    1,
                    2,
                    3
                ],
                "includeSubFolders": true,
                "displayPropertyFieldId": "startEnd"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "dnzd",
                        "value": [
                            "xcCyuq"
                        ],
                        "systemFieldId": "event.assignedToUserId"
                    },
                    {
                        "type": "date-relative-after",
                        "id": "bu1c",
                        "value": 0,
                        "systemFieldId": "event.startDate"
                    },
                    {
                        "type": "date-relative-before",
                        "id": "dp1x",
                        "value": 30,
                        "systemFieldId": "event.startDate"
                    }
                ],
                "logicalOperator": "AND"
            },
            "title": "Upcoming milestones",
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 0
            },
            "type": "event-list",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "showPercents": false,
                "includeSubFolders": true,
                "showClosedTasks": false,
                "groupBy": "statusId",
                "counterType": "tasks-total"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "4zog",
                        "value": [
                            gd.user.id
                        ],
                        "systemFieldId": "task.assignedToUserId"
                    }
                ],
                "logicalOperator": "AND"
            },
            "title": "Tasks by Status",
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 4
            },
            "type": "tasks-summary",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "showPercents": false,
                "includeSubFolders": true,
                "showClosedTasks": false,
                "groupBy": "taskTypeId",
                "counterType": "tasks-total"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "t23i",
                        "value": [
                            gd.user.id
                        ],
                        "systemFieldId": "task.assignedToUserId"
                    },
                    {
                        "type": "includes",
                        "id": "u9ie",
                        "value": [
                            gd.user.id
                        ],
                        "systemFieldId": "task.actionRequiredUserId"
                    }
                ],
                "logicalOperator": "AND"
            },
            "title": "Tasks by Type",
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 8
            },
            "type": "tasks-summary",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "userIds": [
                    gd.user.id
                ],
                "includeSubFolders": true,
                "daterange": {
                    "start": -30,
                    "end": 0
                }
            },
            "color": 6,
            "conditions": null,
            "title": "Time reporting by day",
            "gridPosition": {
                "y": 4,
                "h": 2,
                "w": 6,
                "x": 0
            },
            "type": "time-reported-by-day",
            "id": generateUniqueId()
        },
        {
            "cardLayout": "none",
            "settings": {
                "displayGrid": true
            },
            "color": 6,
            "text": null,
            "title": "Quick notes",
            "gridPosition": {
                "y": 4,
                "h": 2,
                "w": 6,
                "x": 6
            },
            "conditions": null,
            "type": "quick-notes",
            "id": generateUniqueId()
        }
    ]

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.CUSTOM,
        "widgets"   : widgetsConfig
    }

    return dashboardConfig
}

